export default __webpack_public_path__ + "866fbab25a8e236355b739bfe2696d9a.svg";